import { styled } from 'styled-components';
import {
    CommonButtonProps,
    IGNORE_BUTTON_PROPS,
    buttonBackgroundColor,
    buttonBorder,
    buttonColor,
} from '../button/button.utils';
import { Size } from '../../types';

export const StyledIconButton = styled.button.withConfig({
    shouldForwardProp: (prop) => {
        return !['size', 'icon', '$circular', ...IGNORE_BUTTON_PROPS].includes(prop);
    },
})<CommonButtonProps & { $circular?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border-radius: ${({ theme, size = Size.NORMAL, $circular }) =>
        $circular
            ? theme.componentSizes.iconButton[size].radius
            : theme.componentSizes.button[size].radius}px;
    background-color: ${buttonBackgroundColor};
    color: ${buttonColor};
    border: ${buttonBorder};

    cursor: ${(props) => (props.disabled || props.loading ? 'not-allowed' : 'pointer')};

    width: ${({ theme, size = Size.NORMAL }) => theme.componentSizes.iconButton[size].height}px;
    height: ${({ theme, size = Size.NORMAL }) => theme.componentSizes.iconButton[size].height}px;
    padding: ${({ theme, size = Size.NORMAL }) => theme.componentSizes.iconButton[size].padding}px;

    svg {
        color: ${buttonColor};
        width: ${({ theme, size = Size.NORMAL }) =>
            theme.componentSizes.iconButton[size].iconSize}px;
        height: ${({ theme, size = Size.NORMAL }) =>
            theme.componentSizes.iconButton[size].iconSize}px;
    }
`;
